import type { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import ErrorPage from '../components/ErrorPage';
import { LoadingFallback } from '../components/QueryResults/LoadingFallback';
import { useRoyaltiesRegistrationClearance } from '../hooks/useRoyaltiesRegistrationClearance';

/**
 * Route guard for a page that opens a secondary-royalties registration: Current
 * Members only, everyone else sees not-found. Unlike `RequireCurrentMember` it
 * keeps an open form mounted while a stale workspace re-checks membership.
 */
export const RequireRoyaltiesRegistration = ({
  children,
}: PropsWithChildren) => {
  const { pathname } = useLocation();
  const { isPending, isRefused, retry } =
    useRoyaltiesRegistrationClearance(pathname);

  if (isPending) return <LoadingFallback />;

  // A failed check is not a verdict, so it gets a retry rather than not-found.
  if (isRefused) {
    return retry ? (
      <ErrorPage genericError onRetry={retry} />
    ) : (
      <ErrorPage notFound />
    );
  }

  return <>{children}</>;
};
